import React, { useEffect, useState } from 'react';
import { FormControlLabel, LinearProgress, Radio, RadioGroup, TextField, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { actionCreators as selfServiceActionCreators } from '../../redux/actions/selfServiceActions';
import * as types from '../../redux/actions/actionTypes';
import IdentificationDocument from './IdentificationDocument';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Button from '@material-ui/core/Button';
import NewIdentificationDocument from './NewIdentificationDocument';
import { buildEmptyNewIdentificationDocument } from './Util/identificationDocuments.util';
import AddIcon from '@material-ui/icons/Add';
const basicRowStyle = {
	display: `flex`,
	flexDirection: `row`,
	justifyContent: `space-between`,
	marginTop: `20px`,
	alignItems: `center`,
};

const CreateIdentificationDocument = (props) => {
	const {
		showSnackBar,
		newIdentificationDocuments,
		countriesList,
		setFieldState,
		addNewIdentificationDocument,
		removeIdentificationDocument,
		fieldErrors,
		setFieldError
	} = props;

	const dispatch = useDispatch();
	const identificationDocumentTypes = useSelector((state) => state.selfService.IdentificationDocumentTypes);
	const isLoading = useSelector((state) => state.selfService.isWaitingRequest);
	const [documentType, setDocumentType] = useState({});
	const [issuingCountry, setIssuingCountry] = useState({});
	const [documentId, setDocumentId] = useState('');

	useEffect(() => {
		const fetchData = async () => {
			const response = await dispatch(selfServiceActionCreators.getAllIdentificationDocumentTypes());
			dispatch({ type: types.identificationDocumentTypesSuccess, IdentificationDocumentTypes: response.data });
		};
		if (!identificationDocumentTypes) fetchData();
	}, [identificationDocumentTypes]);

	const handleDocumentTypeChange = (newValue) => {
		newValue = newValue ? newValue : {};
		setDocumentType(newValue);
	};
	const handleIssuingCountryChange = (newValue) => {
		newValue = newValue ? newValue : {};
		setIssuingCountry(newValue);
	};

	const addNewDocumentHandleClick = () => {
		const newIdentificationDocument = buildEmptyNewIdentificationDocument(
			documentType.Code,
			documentType.Name,
			documentId,
			issuingCountry.Code
		);
		addNewIdentificationDocument(newIdentificationDocument);
		setDocumentId('');
		setDocumentType({});
		setIssuingCountry({});
	};

	const addNewIdCardEnabled = () => {
		return documentType && documentType.Code &&
			documentId && documentId.length > 0 &&
			issuingCountry && issuingCountry.Code
	}

	return (
		<fieldset className='entity-fieldset'>
			<Typography component='legend' color='primary'>
				<legend>New Identification Documents</legend>
			</Typography>
			{!identificationDocumentTypes ? (
				<>
					<div className='login-loader-message'>Loading Data...</div>
					<LinearProgress />
				</>
			) : (
					<>
						<div style={{ ...basicRowStyle, padding: 20, marginBottom: `20px` }}>
							<Autocomplete
								id='auto-complete-id-type-auto-complete'
								style={{ width: 220 }}
								value={identificationDocumentTypes.find((c) => c.Code === documentType.Code)}
								onChange={(event, newValue) => {
									handleDocumentTypeChange(newValue);
								}}
								options={identificationDocumentTypes}
								getOptionLabel={(option) => option.Name}
								renderInput={(params) => (
									<TextField {...params} label='Document Type' variant='outlined' required />
								)}
							/>
							<TextField
								value={documentId}
								onChange={(newValue) => setDocumentId(newValue.target.value)}
								label='Document ID'
								variant='filled'
								required
							/>
							<Autocomplete
								id='auto-complete-id-docs-countries'
								value={countriesList.find((c) => c.Code === issuingCountry.Code)}
								onChange={(event, newValue) => {
									handleIssuingCountryChange(newValue);
								}}
								options={countriesList}
								getOptionLabel={(option) => option.Name}
								renderInput={(params) => <TextField {...params} label='Country' variant='outlined' required />}
							/>
							<Button
								size='small'
								style={{ width: `150px`, height: `30px` }}
								variant='contained'
								color='primary'
								startIcon={<AddIcon />}
								disabled={!addNewIdCardEnabled()}
								onClick={addNewDocumentHandleClick}
							>
								Add
						</Button>
						</div>
						<div>
							{newIdentificationDocuments.map((newIdentificationDocument, index) => (
								<div key={`IdentificationDocument${newIdentificationDocument.DocumentID}`} id={`IdentificationDocument${newIdentificationDocument.DocumentID}`}>
									<IdentificationDocument
										showSnackBar={showSnackBar}
										setFieldState={(newValue) => setFieldState(newValue, index)}
										countriesList={countriesList}
										identificationDocument={newIdentificationDocument}
										addingMode={true}
										setFieldError={(error) => setFieldError(error, index)}
										removeIdentificationDocument={removeIdentificationDocument}
										fieldError={
											fieldErrors && fieldErrors.find(x => x.FieldCode == `IdentificationDocument${newIdentificationDocument.DocumentID}`)
												? fieldErrors.find(x => x.FieldCode == `IdentificationDocument${newIdentificationDocument.DocumentID}`)["ErrorMessage"]
												: null
										}
									/>
								</div>
							))}
						</div>
					</>
				)}
		</fieldset>
	);
};

export default CreateIdentificationDocument;
